// Lightweight haptics wrapper. No-op on web, real impact on native.
// Use sparingly — on key tactile moments only (button confirm, paywall buy,
// score reveal, photo capture). Over-use makes the app feel cheap.
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNativeApp } from "./platform";

export async function tapLight() {
  if (!isNativeApp()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* haptics unsupported on this device — non-fatal */
  }
}

export async function tapMedium() {
  if (!isNativeApp()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    /* non-fatal */
  }
}

export async function tapHeavy() {
  if (!isNativeApp()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch {
    /* non-fatal */
  }
}

export async function notifySuccess() {
  if (!isNativeApp()) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    /* non-fatal */
  }
}

export async function notifyError() {
  if (!isNativeApp()) return;
  try {
    await Haptics.notification({ type: NotificationType.Error });
  } catch {
    /* non-fatal */
  }
}

export async function selection() {
  if (!isNativeApp()) return;
  try {
    await Haptics.selectionStart();
    await Haptics.selectionChanged();
    await Haptics.selectionEnd();
  } catch {
    /* non-fatal */
  }
}
